<app-loader
  [show]="isLoading"
  [mainMessage]="'IMPORT_EMPLOYEES.LOADING_MESSAGE' | translate"
  [subMessage]="'IMPORT_EMPLOYEES.LOADING_SUB_MESSAGE' | translate"
>
</app-loader>

<app-header></app-header>

<div class="flex flex-col min-h-screen bg-gray-50 font-sans">
  <main class="flex-grow w-full pb-10">
    <!-- Main Container with Sidebar -->
    <div class="flex mx-auto">
      <!-- Left Sidebar - Stepper & Summary -->
      <app-stepper [currentStep]="2"></app-stepper>

      <!-- Main Content Area -->
      <div class="w-[80%] px-8 py-8">
        <h1 class="text-3xl font-bold mb-2 text-gray-900">
          {{ "IMPORT_EMPLOYEES.PAGE_TITLE" | translate }}
        </h1>
        <p class="text-gray-600 mb-8">
          {{ "IMPORT_EMPLOYEES.PAGE_DESC" | translate }}
        </p>
        <div class="flex gap-6">
          <!-- Left Section - Add New Member -->
          <div
            class="bg-white border border-gray-200 p-6 rounded-lg shadow-sm w-[65%]"
          >
            <div class="flex justify-between items-center mb-6">
              <h2 class="text-lg font-semibold text-gray-900">
                {{ "IMPORT_EMPLOYEES.ADD_NEW_MEMBER" | translate }}
              </h2>
              <button
                type="button"
                (click)="clearInputs()"
                class="text-sm text-gray-500 hover:text-gray-700 hover:underline"
              >
                {{ "IMPORT_EMPLOYEES.CLEAR_INPUTS" | translate }}
              </button>
            </div>

            <!-- Member Type Toggle -->
            <div class="mb-5">
              <label class="block text-sm font-medium text-gray-700 mb-2">{{
                "IMPORT_EMPLOYEES.MEMBER_TYPE" | translate
              }}</label>
              <div class="flex gap-2">
                <button
                  (click)="memberType = 'Employee'"
                  [ngClass]="{
                    'bg-gray-900 text-white': memberType === 'Employee',
                    'bg-transparent text-gray-600 border border-gray-300 rounded-lg':
                      memberType !== 'Employee'
                  }"
                  class="flex-1 px-4 py-2.5 rounded-md font-medium transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <img
                    src="assets/icons/employee.svg"
                    alt=""
                    class="w-5 h-5"
                    [ngClass]="
                      memberType === 'Employee' ? 'invert-0' : 'invert'
                    "
                  />
                  {{ "IMPORT_EMPLOYEES.EMPLOYEE" | translate }}
                </button>
                <button
                  (click)="memberType = 'Dependent'"
                  [ngClass]="{
                    'bg-gray-900 text-white': memberType === 'Dependent',
                    'bg-transparent text-gray-600 border border-gray-300 rounded-lg':
                      memberType !== 'Dependent'
                  }"
                  class="flex-1 px-4 py-2.5 rounded-md font-medium transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <img
                    src="assets/icons/dependent.svg"
                    alt=""
                    [ngClass]="
                      memberType === 'Dependent' ? 'invert' : 'invert-0'
                    "
                    class="w-5 h-5"
                  />
                  {{ "IMPORT_EMPLOYEES.DEPENDENT" | translate }}
                </button>
              </div>
            </div>

            <!-- Two Column Layout for Names -->
            <div class="grid grid-cols-2 gap-4 mb-5">
              <div>
                <label
                  for="firstName"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "IMPORT_EMPLOYEES.FIRST_NAME" | translate }}
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  [placeholder]="
                    'IMPORT_EMPLOYEES.PLACEHOLDERS.FIRST_NAME' | translate
                  "
                  [(ngModel)]="firstName"
                  class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label
                  for="lastName"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "IMPORT_EMPLOYEES.LAST_NAME" | translate }}
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  [placeholder]="
                    'IMPORT_EMPLOYEES.PLACEHOLDERS.LAST_NAME' | translate
                  "
                  [(ngModel)]="lastName"
                  class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4 mb-5">
              <div>
                <label
                  for="nameAr"
                  class="block text-sm font-medium text-gray-700 mb-2"
                  >{{ "IMPORT_EMPLOYEES.NAME_IN_ARABIC" | translate }}</label
                >
                <input
                  type="text"
                  id="nameAr"
                  placeholder="الاسم بالعربية"
                  [(ngModel)]="nameAr"
                  class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label
                  for="memberId"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "IMPORT_EMPLOYEES.MEMBER_ID" | translate }}
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="memberId"
                  [placeholder]="
                    'IMPORT_EMPLOYEES.PLACEHOLDERS.MEMBER_ID' | translate
                  "
                  [(ngModel)]="memberId"
                  class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>
            <div class="mb-5" *ngIf="memberType === 'Dependent'">
              <label
                for="employeeId"
                class="block text-sm font-medium text-gray-700 mb-2"
                >{{
                  "IMPORT_EMPLOYEES.DEPENDENT_SPONSOR_ID" | translate
                }}</label
              >
              <input
                type="text"
                id="employeeId"
                [placeholder]="
                  'IMPORT_EMPLOYEES.PLACEHOLDERS.DEPENDENT_SPONSOR_ID'
                    | translate
                "
                [(ngModel)]="employeeId"
                class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
            </div>

            <!-- Two Column Layout for Gender and DOB -->
            <div class="grid grid-cols-2 gap-4 mb-5">
              <div>
                <label
                  for="gender"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "IMPORT_EMPLOYEES.GENDER" | translate }}
                  <span class="text-red-500">*</span>
                </label>
                <select
                  id="gender"
                  [(ngModel)]="gender"
                  class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                >
                  <option value="" disabled selected>
                    {{ "IMPORT_EMPLOYEES.SELECT_GENDER" | translate }}
                  </option>
                  <option value="Male">
                    {{ "IMPORT_EMPLOYEES.MALE" | translate }}
                  </option>
                  <option value="Female">
                    {{ "IMPORT_EMPLOYEES.FEMALE" | translate }}
                  </option>
                </select>
              </div>
              <div>
                <label
                  for="dateOfBirth"
                  class="block text-sm font-medium text-gray-700 mb-2"
                >
                  {{ "IMPORT_EMPLOYEES.DATE_OF_BIRTH" | translate }}
                  <span class="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  id="dateOfBirth"
                  placeholder="dd-mm-yyyy"
                  [(ngModel)]="dateOfBirth"
                  class="w-full px-4 py-3.5 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <!-- Job Title (Employee only) -->
            <div *ngIf="memberType === 'Employee'" class="mb-5">
              <label
                for="jobTitle"
                class="block text-sm font-medium text-gray-700 mb-2"
                >{{ "IMPORT_EMPLOYEES.JOB_TITLE" | translate }}</label
              >
              <input
                type="text"
                id="jobTitle"
                [placeholder]="
                  'IMPORT_EMPLOYEES.PLACEHOLDERS.JOB_TITLE' | translate
                "
                [(ngModel)]="jobTitle"
                class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
            </div>

            <!-- Mobile Number -->
            <div class="mb-5">
              <label
                for="mobileNumber"
                class="block text-sm font-medium text-gray-700 mb-2"
                >{{ "IMPORT_EMPLOYEES.MOBILE_NUMBER" | translate }}</label
              >
              <input
                type="text"
                id="mobileNumber"
                [placeholder]="
                  'IMPORT_EMPLOYEES.PLACEHOLDERS.MOBILE_NUMBER' | translate
                "
                [(ngModel)]="mobileNumber"
                class="w-full px-4 py-4 bg-[#F3F3F5] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
            </div>

            <!-- Insurance Plan -->
            <div class="mb-5">
              <label class="block text-sm font-medium text-gray-700 mb-2">{{
                "IMPORT_EMPLOYEES.INSURANCE_PLAN" | translate
              }}</label>
              <div class="flex gap-2">
                <div *ngFor="let plan of insurancePlans" class="flex-1">
                  <input
                    type="radio"
                    name="insurancePlan"
                    [id]="plan"
                    [value]="plan"
                    [(ngModel)]="selectedPlan"
                    class="hidden peer"
                  />
                  <label
                    [for]="plan"
                    class="block text-center px-4 py-4 bg-[#F3F3F5] border border-gray-300 rounded-lg cursor-pointer text-sm font-medium transition-all peer-checked:bg-gray-900 peer-checked:text-white peer-checked:border-gray-900 hover:border-gray-400"
                  >
                    {{ "IMPORT_EMPLOYEES.INSURANCE_PLANS." + plan | translate }}
                  </label>
                </div>
              </div>
            </div>

            <!-- Is Married Checkbox -->
            <div class="mb-6">
              <label class="flex items-center cursor-pointer">
                <input
                  id="isMarried"
                  type="checkbox"
                  [(ngModel)]="isMarried"
                  class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span class="ml-2 text-sm font-medium text-gray-700">{{
                  "IMPORT_EMPLOYEES.IS_MARRIED" | translate
                }}</span>
              </label>
            </div>

            <!-- Add Member Button -->
            <button
              type="button"
              (click)="onSaveMember()"
              class="w-full bg-[#00BBA7] hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
            >
              <span class="text-xl">+</span>
              {{ "IMPORT_EMPLOYEES.ADD_MEMBER" | translate }}
            </button>
          </div>

          <!-- Right Section - Added Members & Upload -->
          <div class="flex flex-col w-[35%] gap-6">
            <!-- Added Members List -->
            <div
              class="bg-white border border-gray-200 p-6 rounded-lg shadow-sm"
            >
              <h3 class="text-lg font-semibold text-gray-900 mb-4">
                {{ "IMPORT_EMPLOYEES.ADDED_MEMBERS" | translate }} ({{
                  totalMembersCount
                }})
              </h3>

              <div
                *ngIf="
                  employeesWithDependents && employeesWithDependents.length > 0
                "
                class="space-y-4 max-h-80 overflow-y-auto"
              >
                <!-- Employee with Dependents -->
                <div
                  *ngFor="let employee of employeesWithDependents"
                  class="space-y-2"
                >
                  <!-- Employee Card -->
                  <div
                    class="flex items-center justify-between p-3 bg-[#F0FDF4] border border-blue-200 rounded-lg"
                  >
                    <div class="flex items-center gap-3">
                      <div
                        class="w-10 h-10 bg-[#00C950] text-white rounded-full flex items-center justify-center font-semibold text-sm"
                      >
                        {{ employee.initials }}
                      </div>
                      <div>
                        <p class="font-medium text-gray-900">
                          {{ employee.firstNameEn }} {{ employee.lastNameEn }}
                        </p>
                        <p class="text-sm text-[#00C950]">
                          {{ "IMPORT_EMPLOYEES.EMPLOYEE" | translate }} ·
                          {{ "IMPORT_EMPLOYEES.ID" | translate }}
                          {{ employee.idNumber || employee.memberId }}
                        </p>
                      </div>
                    </div>
                    <button
                      (click)="onDeleteMember(employee)"
                      class="text-red-500 hover:text-red-700 p-1 rounded transition-colors"
                      [title]="'IMPORT_EMPLOYEES.DELETE_EMPLOYEE' | translate"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M10 11v6M14 11v6"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <!-- Dependents connected to this employee -->
                  <div
                    *ngIf="
                      employee.dependentList &&
                      employee.dependentList.length > 0
                    "
                    class="ml-6 space-y-2"
                  >
                    <div class="relative">
                      <!-- Connection line -->
                      <div
                        class="absolute -left-4 top-0 w-4 h-full border-l-2 border-gray-300"
                      ></div>

                      <div
                        *ngFor="
                          let dependent of employee.dependentList;
                          let isLast = last
                        "
                        class="relative"
                      >
                        <!-- Connection branch -->
                        <div
                          class="absolute -left-4 top-5 w-4 h-0.5 bg-gray-300"
                        ></div>
                        <!-- End cap for last dependent -->
                        <div
                          *ngIf="isLast"
                          class="absolute -left-4 top-5 w-0.5 h-full bg-white"
                        ></div>

                        <!-- Dependent Card -->
                        <div
                          class="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg ml-2"
                        >
                          <div class="flex items-center gap-3">
                            <div
                              class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-semibold text-xs"
                            >
                              {{ dependent.initials }}
                            </div>
                            <div>
                              <p class="font-medium text-gray-900 text-sm">
                                {{ dependent.firstNameEn }}
                                {{ dependent.lastNameEn }}
                              </p>
                              <p class="text-xs text-green-600">
                                {{ "IMPORT_EMPLOYEES.DEPENDENT" | translate }} ·
                                {{ "IMPORT_EMPLOYEES.ID" | translate }}
                                {{ dependent.idNumber || dependent.memberId }}
                              </p>
                            </div>
                          </div>
                          <button
                            (click)="onDeleteMember(dependent)"
                            class="text-red-500 hover:text-red-700 p-1 rounded transition-colors"
                            [title]="
                              'IMPORT_EMPLOYEES.DELETE_DEPENDENT' | translate
                            "
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M10 11v6M14 11v6"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                *ngIf="
                  !employeesWithDependents ||
                  employeesWithDependents.length === 0
                "
                class="text-center py-8 text-gray-400"
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mx-auto mb-4 text-gray-300"
                >
                  <path
                    d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p>{{ "IMPORT_EMPLOYEES.NO_MEMBERS_ADDED" | translate }}</p>
              </div>
            </div>

            <!-- Upload via Excel Section -->
            <div
              class="bg-white border border-gray-200 p-6 rounded-lg shadow-sm"
            >
              <h3 class="text-lg font-semibold text-gray-900 mb-2">
                {{ "IMPORT_EMPLOYEES.UPLOAD_VIA_EXCEL" | translate }}
              </h3>
              <p class="text-sm text-gray-600 mb-4">
                {{ "IMPORT_EMPLOYEES.UPLOAD_DESC" | translate }}
              </p>

              <button
                type="button"
                (click)="downloadTemplate()"
                class="w-full mb-4 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
              >
                <img
                  src="assets/icons/download-template.svg"
                  alt=""
                  class="w-5 h-5"
                />
                {{ "IMPORT_EMPLOYEES.DOWNLOAD_TEMPLATE" | translate }}
              </button>

              <!-- File Upload Area -->
              <div
                class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-gray-400 transition-colors"
              >
                <div class="flex justify-center mb-3">
                  <img
                    src="assets/icons/upload-excel.svg"
                    alt=""
                    class="w-12 h-12"
                  />
                </div>
                <p class="text-sm font-medium text-gray-700 mb-1">
                  {{ "IMPORT_EMPLOYEES.CHOOSE_FILE_OR_DRAG" | translate }}
                </p>
                <div
                  *ngIf="selectedFile"
                  class="mb-3 p-2 bg-green-50 border border-green-200 rounded-lg"
                >
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="text-green-600"
                      >
                        <path
                          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 2v6h6"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span class="text-xs text-green-700 font-medium">{{
                        selectedFile.name
                      }}</span>
                    </div>
                    <button
                      (click)="onRemoveFile(fileInput)"
                      class="text-red-500 hover:text-red-700 p-1 rounded transition-colors"
                      title="Remove file"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 6L6 18M6 6l12 12"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <input
                  type="file"
                  hidden
                  #fileInput
                  (change)="onFileSelected($event)"
                  accept=".xlsx"
                />
                <button
                  (click)="fileInput.click()"
                  class="bg-white border text-black font-medium px-6 py-2 rounded-lg text-sm transition-colors duration-200"
                  [class.mb-0]="selectedFile"
                >
                  {{
                    selectedFile
                      ? ("IMPORT_EMPLOYEES.CHOOSE_DIFFERENT_FILE" | translate)
                      : ("IMPORT_EMPLOYEES.UPLOAD_FILE" | translate)
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between mt-8">
          <button
            (click)="handleBack()"
            class="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors flex items-center gap-2"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rotate-180"
            >
              <path
                d="M7.5 15L12.5 10L7.5 5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {{ "IMPORT_EMPLOYEES.BACK_TO_COMPANY_DETAILS" | translate }}
          </button>

          <button
            (click)="onNextClick()"
            class="bg-[#00BBA7] text-white font-medium px-8 py-2.5 rounded-lg transition-colors duration-200 flex items-center gap-2"
          >
            {{ "IMPORT_EMPLOYEES.CONTINUE_TO_HEALTH_DECLARATION" | translate }}
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 15L12.5 10L7.5 5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </main>
</div>

<app-footer *ngIf="!isDashboard" layout="slim"></app-footer>

<!-- Error Popup Modal -->
<div
  *ngIf="showErrorPopup"
  class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
>
  <div
    class="bg-white rounded-lg shadow-xl p-6 max-w-md max-h-[80vh] overflow-y-auto"
  >
    <h2 class="text-lg font-semibold text-red-600 mb-4">Error</h2>
    <div class="text-gray-700 mb-6" [innerHTML]="errorMessage"></div>
    <button
      (click)="closeErrorPopup()"
      class="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
    >
      Close
    </button>
  </div>
</div>
